import React from "react"
import i18n from "@/i18n"

const STYLES = {
  container: "flex gap-[134px]",
  column: "flex flex-col",
  heading: "text-sm font-semibold text-white mb-[25px]",
  linkGroup: "flex flex-col gap-[19px]",
  link: "cursor-default text-left text-xs text-neutral-300 no-underline disabled:opacity-100",
} as const

const LinkColumns: React.FC = () => {
  const t = (key: string) => i18n.t(`app.public.venue.footer.${key}`)

  return (
    <div className={STYLES.container}>
      <div className={STYLES.column}>
        <h3 className={STYLES.heading}>{t("for_business")}</h3>
        <div className={STYLES.linkGroup}>
          <button type="button" disabled className={STYLES.link}>
            {t("partner_with_us")}
          </button>
          <button type="button" disabled className={STYLES.link}>
            {t("about_tabb")}
          </button>
          <button type="button" disabled className={STYLES.link}>
            {t("contact_us")}
          </button>
        </div>
      </div>
      <div className={STYLES.column}>
        <h3 className={STYLES.heading}>{t("learn_more")}</h3>
        <div className={STYLES.linkGroup}>
          <button type="button" disabled className={STYLES.link}>
            {t("privacy_policy")}
          </button>
          <button type="button" disabled className={STYLES.link}>
            {t("terms_of_service")}
          </button>
          <button type="button" disabled className={STYLES.link}>
            {t("data_processing")}
          </button>
        </div>
      </div>
    </div>
  )
}

export default LinkColumns
